class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.daysEl = this.querySelector('.countdown-timer__days');
        this.hoursEl = this.querySelector('.countdown-timer__hours');
        this.minutesEl = this.querySelector('.countdown-timer__minutes');
        this.secondsEl = this.querySelector('.countdown-timer__seconds');

        if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) return;

        this.expiryDateStr = this.dataset.expiryDate;
        this.hideExpired = this.dataset.hideExpired === 'true';

        this.endDate = this.calculateEndDate();
        if (!this.endDate || isNaN(this.endDate.getTime())) return;

        this.start();
    }

    calculateEndDate() {
        if (!this.expiryDateStr) return null;

        const parts = this.expiryDateStr.split('-');
        if (parts.length !== 3) return null;

        let year, month, day;
        if (parts[0].length === 4) {
            [year, month, day] = parts; // YYYY-MM-DD
        } else {
            [day, month, year] = parts; // DD-MM-YYYY
        }

        // End of day in local time
        return new Date(`${year}-${month}-${day}T23:59:59`);
    }

    start() {
        this.update();
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(this.update.bind(this), 1000);
    }

    update() {
        const now = new Date();
        const distance = this.endDate.getTime() - now.getTime();

        if (distance < 0) {
            clearInterval(this.timer);
            if (this.hideExpired) {
                this.style.display = 'none';
            } else {
                this.render(0, 0, 0, 0);
            }
            return;
        }

        this.render(
            Math.floor(distance / (1000 * 60 * 60 * 24)),
            Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            Math.floor((distance % (1000 * 60)) / 1000)
        );
    }

    render(days, hours, minutes, seconds) {
        if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
}

if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
}
